import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Checkbox,
  Row,
  Col,
  Alert,
  Card,
  message
} from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import moment from 'moment';
import { useNavigate, NavLink } from 'react-router-dom';
import Cookies from "js-cookie";
import axios from '../../../../helpers/Axios'

const { Option } = Select;
const { RangePicker } = DatePicker;

const Register = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const [sameAddress, setSameAddress] = useState(false);

  const [sections, setSections] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subClasses, setSubClasses] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [barangays, setBarangays] = useState([]);
  const [regions2, setRegions2] = useState([]);
  const [provinces2, setProvinces2] = useState([]);
  const [cities2, setCities2] = useState([]);
  const [barangays2, setBarangays2] = useState([]);
  const [titles, setTitles] = useState([]);
  const [suffixes, setSuffixes] = useState([]);
  const [geocode, setGeocode] = useState([]);
  const [location, setLocation] = useState('');

  const [divisionsDisabled, setDivisionsDisabled] = useState(true);
  const [groupDisabled, setGroupDisabled] = useState(true);
  const [classDisabled, setClassDisabled] = useState(true);
  const [subClassDisabled, setSubClassDisabled] = useState(true);
  const [provinceDisabled, setProvinceDisabled] = useState(true);
  const [cityDisabled, setCityDisabled] = useState(true);
  const [barangayDisabled, setBarangayDisabled] = useState(true);
  const [provinceDisabled2, setProvinceDisabled2] = useState(true);
  const [cityDisabled2, setCityDisabled2] = useState(true);
  const [barangayDisabled2, setBarangayDisabled2] = useState(true);

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  // const apiPath = '';
  // const token = Cookies.get("access_token");

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    try {
      const [sectionRes, regionsRes, titlesRes, suffixesRes] = await Promise.all([
        axios.get('/api/sections'),
        axios.get('/api/get_region/?country=1'),
        axios.get('/api/title_view'),
        axios.get('/api/suffix_view'),
      ]);
      setSections(sectionRes.data);
      setRegions(regionsRes.data);
      setRegions2(regionsRes.data);
      setTitles(titlesRes.data);
      setSuffixes(suffixesRes.data);
    } catch (error) {
      message.error('Failed to fetch initial data');
    }
  };

  const handleSectionChange = useCallback(async (value) => {
    if (value) {
      const res = await axios.get(`/api/division_filter/?section_id=${value}`);
      
      setDivisions(res.data);
      setDivisionsDisabled(false);
      setGroups([]);
      setGroupDisabled(true);
      setClasses([]);
      setClassDisabled(true);
      setSubClasses([]);
      setSubClassDisabled(true);
    }
  }, []);

  const handleDivisionChange = useCallback(async (value) => {
    if (value) {
      const res = await axios.get(`/api/group_filter/?division_id=${value}`);
      
      setGroups(res.data);
      setGroupDisabled(false);
      setClasses([]);
      setClassDisabled(true);
      setSubClasses([]);
      setSubClassDisabled(true);
    }
  }, []);

  const handleProvinceChange = useCallback(async (value) => {
    if (value) {
      const res = await axios.get(`/api/get_city/?province=${value}`);
      
      setCities(res.data);
      setCityDisabled(false);
      setBarangays([]);
      setBarangayDisabled(true);
      setGeocode('');
      setLocation('');
    }
  }, []);

  const handleCityChange = useCallback(async (value) => {
    if (value) {
      const [cityRes, barangayRes] = await Promise.all([
        axios.get(`/api/cities/${value}`),
        axios.get(`/api/get_barangay/?city=${value}`),
      ]);

      setGeocode(cityRes.data.psgccode);
      setLocation(cityRes.data.name);
      setBarangays(barangayRes.data);
      setBarangayDisabled(false);
    }
  }, []);

  const handleGroupChange = useCallback(async (value) => {
    if (!value) return;
    try {
      const res = await axios.get(
        `/api/class_filter/?group_id=${value}`);
      setClasses(res.data);
      setClassDisabled(false);
      setSubClasses([]);
      setSubClassDisabled(true);
    } catch {
      setClasses([]);
      setClassDisabled(true);
      setSubClasses([]);
      setSubClassDisabled(true);
    }
  }, []);

  const handleClassChange = useCallback(async (value) => {
    if (!value) return;
    try {
      const res = await axios.get(
        `/api/subclass_filter/?class_id=${value}`);
      setSubClasses(res.data);
      setSubClassDisabled(false);
    } catch {
      setSubClasses([]);
      setSubClassDisabled(true);
    }
  }, []);

  const handleProvinceChange2 = useCallback(async (value) => {
    if (!value) return;
    const res = await axios.get(`/api/get_city/?province=${value}`);
    setCities2(res.data);
    setCityDisabled2(false);
    setBarangays2([]);
    setBarangayDisabled2(true);
  }, []);

  const handleCityChange2 = useCallback(async (value) => {
    if (!value) return;
    const res = await axios.get(`/api/get_barangay/?city=${value}`);
    setBarangays2(res.data);
    setBarangayDisabled2(res.data.length === 0);
  }, []);

  const handleBarangayChange = useCallback(async (value) => {
    form.setFieldValue('barangay_office', value);
  }, [form]);

  const handleBarangayChange2 = useCallback((value) => {
    form.setFieldValue('barangay_business', value);
  }, [form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const dateRegistered = moment(values.date_registered).format('MM/DD/YYYY');
      const fiscalYear = values.fiscal_year.format('MM/YYYY');

      const userPayload = {
        password: values.password1,
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
        username: values.email,
        middle_name: values.middleName,
        mobile_no: values.mobileNo,
        contact_address: values.contactAddress,
        role: 23,
        title: values.title,
        suffix: values.suffix,
        status: 4,
      };

      const userRes = await axios.post(`/api/users`, userPayload);
      const userId = userRes.data.id;

      const officePayload = {
        zip_code: values.zipCodeOffice,
        floor: values.floorOffice,
        building: values.buildingOffice,
        number: values.numberOffice,
        street: values.streetOffice,
        country: 1,
        region: values.regionOffice,
        province: values.provinceOffice,
        city: values.cityOffice,
        barangay: values.barangayOffice,
      };
      const officeRes = await axios.post(`/api/office_address`, officePayload);
      const officeId = officeRes.data.id;

      let businessId = officeId;
      if (!sameAddress) {
        const businessPayload = {
          zip_code: values.zipCodeBusiness,
          floor: values.floorBusiness,
          building: values.buildingBusiness,
          number: values.numberBusiness,
          street: values.streetBusiness,
          country: 1,
          region: values.regionBusiness,
          province: values.provinceBusiness,
          city: values.cityBusiness,
          barangay: values.barangayBusiness,
        };
        const businessRes = await axios.post(`/api/business_address`, businessPayload);
        businessId = businessRes.data.id;
      }

      const companyPayload = {
        name: values.company_name,
        sec_no: values.sec_no,
        date_registered: values.dateRegistered,
        fiscal_year: values.fiscalYear,
        office_address: values.officialAddress,
        business_address: values.businessAddress,
        user: values.userId,
        psic: values.subClass,
        status: 1,
      }
      await axios.post(`/api/company`, companyPayload);

      setAlertType('Success');
      setAlertMessage('Registration successful!');
      setVisibleAlert(true);
      setTimeout(() => navigate('/user/successfully-registered'), 3000);
    } catch (error) {
      setAlertType('Failed');
      setAlertMessage(error.response?.data?.email || 'Registration failed');
      setVisibleAlert(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-8">
      <div className="max-w-4xl mx-auto">
        <Card className="mt-10 shadow-2xl rounded-2xl">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-gray-800 mb-2">
              Register New Company
            </h3>
          </div>

          {visibleAlert && (
            <Alert
              message={alertMessage}
              type={alertType === 'Success' ? 'success' : 'error'}
              closable
              afterClose={() => setVisibleAlert(false)}
              className="mb-6"
            />
          )}

          <Form
            form={form}
            name="register"
            onFinish={onFinish}
            layout="vertical"
            className="space-y-8"
            requiredMark={false}
          >
            {/* Company Information Section */}
            <div>
              <h5 className="text-xl font-semibold mb-4 text-gray-700 border-b pb-2">
                Company Information
              </h5>
              <Row gutter={24}>
                <Col lg={8} md={12} sm={24}>
                  <Form.Item 
                    name="company_name" 
                    label="Company Name" 
                    rules={[{
                      required: true,
                      min: 2,
                      message: 'Min 2 characters'
                    }]}>
                      <Input placeholder="Enter company name" className="rounded-lg" />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} sm={24}>
                  <Form.Item
                    name="sec_no" 
                    label="SEC Registration No."
                    rules={[{
                      required: true,
                      min: 3,
                      message: 'Minimum 3 characters'
                    }]}
                  >
                    <Input maxLength={15} className="rounded-lg" />
                  </Form.Item>
                </Col>

                <Col lg={5} md={12} sm={24}>
                  <Form.Item
                    name="date_registered"
                    label="Date Registered"
                    rules={[{
                      required: true
                    }]}
                  >
                    <DatePicker 
                      className="w-full rounded-lg"
                      maxDate={moment().toDate()} 
                    />
                  </Form.Item>
                </Col>

                <Col lg={5} md={12} sm={24}>
                  <Form.Item
                    name="fiscal_year"
                    label="Fiscal Year"
                    rules={[{
                      required: true
                    }]}
                  >
                    <DatePicker
                      picker="month"
                      className="w-full rounded-lg"
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* PSIC Section */}
              <div className="mb-6">
                <h6 className="font-medium mb-4 text-gray-600">
                  PSIC Classification
                </h6>
                <Row gutter={24}>
                  <Col lg={6}>
                    <Form.Item
                      name="section"
                      label="Section"
                    >
                      <Select 
                        placeholder="-- SELECT --"
                        onChange={handleSectionChange}
                        className="rounded-lg"
                      >
                        {sections.map((s) => <Option key={s.id} value={s.id}>
                          {s.code} - {s.description}
                        </Option>)}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={6}>
                    <Form.Item
                      name="division"
                      label="Division"
                    >
                      <Select
                        placeholder="-- SELECT --"
                        disabled={divisionsDisabled}
                        onChange={handleDivisionChange}
                        className="rounded-lg"
                      >
                        {divisions.map((d) => <Option key={d.id} value={d.id}>
                          {d.code} - {d.description}
                        </Option>)}
                      </Select>
                    </Form.Item>
                  </Col>
                  
                  <Col lg={4}>
                    <Form.Item
                      name="group"
                      label="Group"
                      rules={[{
                        required: true
                      }]}
                    >
                      <Select
                        placeholder="-- SELECT --"
                        disabled={groupDisabled}
                        onChange={handleGroupChange}
                        className="rounded-lg"
                      >
                        {groups.map((g) => (
                          <Option key={g.id} value={g.id}>
                            {g.code} - {g.description}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  
                  <Col lg={4}>
                    <Form.Item
                      name="class_psic"
                      label="Class"
                      rules={[{
                        required: true
                      }]}
                    >
                      <Select
                        placeholder="-- SELECT --"
                        disabled={classDisabled}
                        onChange={handleClassChange}
                        className="rounded-lg"
                      >
                        {classes.map((c) => (
                          <Option key={c.id} value={c.id}>
                            {c.code} - {c.description}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={4}>
                    <Form.Item
                      name="sub_class"
                      label="Sub-Class"
                      rules={[{
                        required: true
                      }]}
                    >
                      <Select
                        placeholder="-- SELECT --"
                        disabled={subClassDisabled}
                        className="rounded-lg"
                      >
                        {subClasses.map((sc) => (
                          <Option key={sc.id} value={sc.id}>
                            {sc.code} - {sc.description}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              {/* Principal Office Address */}
              <div>
                <span className="block text-base font-semibold text-gray-700 mb-1">
                  Principal Office Address
                </span>
                <div className="border-b mb-3" />

                <Row gutter={24}>
                  <Col lg={4}>
                    <Form.Item
                      name="region_office"
                      label="Region"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="-- SELECT --"
                        onChange={handleProvinceChange}
                        className="rounded-lg"
                      >
                        {regions.map((r) => (
                          <Option key={r.id} value={r.id}>
                            {r.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={6}>
                    <Form.Item
                      name="province_office"
                      label="Province"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="-- SELECT --"
                        disabled={provinceDisabled}
                        onChange={handleCityChange}
                        className="rounded-lg"
                      >
                        {provinces.map((p) => (
                          <Option key={p.id} value={p.id}>
                            {p.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={4}>
                    <Form.Item
                      name="city_office"
                      label="City/Town"
                      rules={[{ required: true }]}
                    >
                      <Select
                        placeholder="-- SELECT --"
                        disabled={cityDisabled}
                        onChange={handleBarangayChange}
                        className="rounded-lg"
                      >
                        {cities.map((c) => (
                          <Option key={c.id} value={c.id}>
                            {c.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={6}>
                    <Form.Item
                      name="barangay_office"
                      label="Barangay"
                      rules={[{ required: true }]}
                    >
                      <Select 
                        placeholder="-- SELECT --"
                        disabled={barangayDisabled}
                        className="rounded-lg"
                      >
                        {barangays.map((b) => (
                          <Option key={b.id} value={b.id}>
                            {b.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={4}>
                    <Form.Item
                      name="zip_code_office"
                      label="Zip Code"
                      rules={[
                        { required: true },
                        { len: 4, message: '4 digits' },
                        { pattern: /^[0-9]+$/, message: 'Numbers only' },
                      ]}
                    >
                      <Input maxLength={4} className="rounded-lg" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col lg={6}>
                    <Form.Item
                      name="floor_office"
                      label="Floor"
                      rules={[{ required: true }]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>

                  <Col lg={6}>
                    <Form.Item
                      name="building_office"
                      label="Building"
                      rules={[{ required: true }]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>

                  <Col lg={6}>
                    <Form.Item
                      name="number_office"
                      label="Number"
                      rules={[{ required: true }]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>

                  <Col lg={6}>
                    <Form.Item
                      name="street_office"
                      label="Street"
                      rules={[{ required: true }]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>
                </Row>

                <div className="border-b mb-3" />
                <Row gutter={24}>
                  <Col lg={12}>
                    <Form.Item label="Geographical Code">
                      <Input
                        value={geocode}
                        disabled
                        className="rounded-lg bg-gray-100"
                      />
                    </Form.Item>
                  </Col>

                  <Col lg={12}>
                    <Form.Item label="Location">
                      <Input
                        value={location}
                        disabled
                        className="rounded-lg bg-gray-100"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item className="mt-2">
                  <Checkbox
                    checked={sameAddress}
                    onChange={(e) => setSameAddress(e.target.checked)}
                  >
                    Business Address same as Principal Office Address
                  </Checkbox>
                </Form.Item>
              </div>

              {/* Business Address */}
              {!sameAddress && (
                <div className="mt-4">
                  <span className="block text-base font-semibold text-gray-700 mb-1">
                    Business Address
                  </span>
                  <div className="border-b mb-3" />

                  <Row gutter={24}>
                    <Col lg={4}>
                      <Form.Item
                        name="region_business"
                        label="Region"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="-- SELECT --"
                          onChange={handleProvinceChange2}
                          className="rounded-lg"
                        >
                          {regions2.map((r) => (
                            <Option key={r.id} value={r.id}>
                              {r.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col lg={6}>
                      <Form.Item
                        name="province_business"
                        label="Province"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="-- SELECT --"
                          disabled={provinceDisabled2}
                          onChange={handleCityChange2}
                          className="rounded-lg"
                        >
                          {provinces2.map((p) => (
                            <Option key={p.id} value={p.id}>
                              {p.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col lg={4}>
                      <Form.Item
                        name="city_business"
                        label="City/Town"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="-- SELECT --"
                          disabled={cityDisabled2}
                          onChange={handleBarangayChange2}
                          className="rounded-lg"
                        >
                          {cities2.map((c) => (
                            <Option key={c.id} value={c.id}>
                              {c.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col lg={6}>
                      <Form.Item
                        name="barangay_business"
                        label="Barangay"
                        rules={[{ required: true }]}
                      >
                        <Select
                          placeholder="-- SELECT --"
                          disabled={barangayDisabled2}
                          className="rounded-lg"
                        >
                          {barangays2.map((b) => (
                            <Option key={b.id} value={b.id}>
                              {b.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col lg={4}>
                      <Form.Item
                        name="zip_code_business"
                        label="Zip Code"
                        rules={[
                          { required: true },
                          { len: 4, message: '4 digits' },
                          { pattern: /^[0-9]+$/, message: 'Numbers only' },
                        ]}
                      >
                        <Input maxLength={4} className="rounded-lg" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={24}>
                    <Col lg={6}>
                      <Form.Item
                        name="floor_business"
                        label="Floor"
                        rules={[{ required: true }]}
                      >
                        <Input className="rounded-lg" />
                      </Form.Item>
                    </Col>

                    <Col lg={6}>
                      <Form.Item
                        name="building_business"
                        label="Building"
                        rules={[{ required: true }]}
                      >
                        <Input className="rounded-lg" />
                      </Form.Item>
                    </Col>

                    <Col lg={6}>
                      <Form.Item
                        name="number_business"
                        label="Number"
                        rules={[{ required: true }]}
                      >
                        <Input className="rounded-lg" />
                      </Form.Item>
                    </Col>

                    <Col lg={6}>
                      <Form.Item
                        name="street_business"
                        label="Street"
                        rules={[{ required: true }]}
                      >
                        <Input className="rounded-lg" />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}

              {/* Contact Person */}
              <div>
                <h5 className="text-xl font-semibold mb-4 text-gray-700 border-b pb-2">
                  Contact Person
                </h5>

                <Row gutter={24}>
                  <Col lg={4} md={12} sm={24}>
                    <Form.Item name="title" label="Title" rules={[{ required: true }]}>
                      <Select className="rounded-lg">
                        {titles.map((t) => (
                          <Option key={t.id} value={t.id}>
                            {t.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col lg={8} md={12} sm={24}>
                    <Form.Item
                      name="last_name"
                      label="Last Name"
                      rules={[{ required: true }]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col lg={6} md={12} sm={24}>
                    <Form.Item
                      name="first_name"
                      label="First Name"
                      rules={[{ required: true }]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>

                  <Col lg={6} md={12} sm={24}>
                    <Form.Item
                      name="middle_name"
                      label="Middle Name"
                      rules={[{ required: true }]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>

                  <Col lg={4} md={12} sm={24}>
                    <Form.Item name="suffix" label="Suffix">
                      <Select className="rounded-lg">
                        {suffixes.map((s) => (
                          <Option key={s.id} value={s.id}>
                            {s.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col lg={12} md={12} sm={24}>
                    <Form.Item
                      name="email"
                      label="Email Address"
                      rules={[
                        { required: true },
                        { type: 'email', message: 'Invalid email' },
                      ]}
                    >
                      <Input className="rounded-lg" />
                    </Form.Item>
                  </Col>

                  <Col lg={12} md={12} sm={24}>
                    <Form.Item
                      name="mobile_no"
                      label="Landline/Mobile No."
                      rules={[
                        { required: true },
                        { min: 8, message: 'Min 8 digits' },
                        { max: 11, message: 'Max 11 digits' },
                      ]}
                    >
                      <Input maxLength={11} className="rounded-lg" />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div>
                <div className="mb-2 text-sm text-gray-500">
                  <span className="text-red-500 mr-1">***</span>
                  Click the eye icon to toggle password view.
                </div>

                <Row gutter={24}>
                  <Col lg={11} md={12} sm={24}>
                    <Form.Item
                      name="password1"
                      label="Password"
                      rules={[
                        { required: true },
                        { min: 8, message: 'At least 8 characters' },
                        {
                          pattern:
                            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[\S]{8,}$/,
                          message:
                            'Must have upper, lower, number, special char, no spaces',
                        },
                      ]}
                    >
                      <Input.Password className="rounded-lg" />
                    </Form.Item>
                  </Col>

                  <Col lg={11} md={12} sm={24}>
                    <Form.Item
                      name="password2"
                      label="Confirm Password"
                      dependencies={['password1']}
                      rules={[
                        { required: true },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue('password1') === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error('Passwords do not match')
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password className="rounded-lg" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col lg={24} md={24} sm={24}>
                    <Form.Item name="contact_address" label="Address">
                      <Input.TextArea rows={2} className="rounded-lg" />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              {/* submit + login link */}
              <div className="flex items-center justify-between pt-4">
                <p className="text-sm md:text-base text-gray-600">
                  If you are a member, please login{' '}
                  <NavLink to="/user/login">
                    <span className="font-semibold text-emerald-700">here</span>
                  </NavLink>
                  .
                </p>

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  size="large"
                  className="px-8 rounded-xl bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 border-none"
                >
                  Submit
                </Button>
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </div>
  );
}

export default Register;